// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Card_3_wrapper__dMJ74"};